// extracted by mini-css-extract-plugin
module.exports = {"checkboxesContainer":"CreateEditClinics_checkboxesContainer__1Sj_K","emails":"CreateEditClinics_emails__1_DVr","emailTagLabel":"CreateEditClinics_emailTagLabel__tOO7E"};